import { colorsPalettes, rgba } from "@similarweb/styles";

export { AI_AGENT_PAGE_WIDTH } from "app/pages/sales-intelligence/modules/ai-agent/constants";

export const MAX_ATTENDEES = 6;

// Shared by the attendees search options and the "add as new" row so keyboard focus looks the
// same on both, now that they live in different folders.
export const ACTIVE_ROW_BACKGROUND = rgba(colorsPalettes.carbon["500"], 0.05);

export const SUGGESTION_TEXTS = ["si.pages.ai_agent_email.suggestion_1", "si.pages.ai_agent_email.suggestion_2"];
